import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer, LabelList
} from 'recharts';
import { formatDate } from '../../exportreport/utils';
import { _formatAxisPrice, _axisWidth } from './chartAxis';


// xInterval maps to recharts' XAxis `interval`: 0 renders every label, 1 every other, and so on.
// It defaults to 0 so existing callers are unchanged; charts with a long series pass a higher
// value to stop the angled labels colliding.
// preformattedLabels: the caller's x values are already display strings ("Q3 2026", "2026") and
// must be printed as-is. Without it they go through formatDate, which re-parses them as dates —
// "Q3 2026" becomes "Invalid Date, NaN" and "2026" becomes "M01, 2025".
const CustomLineChart = ({ theme, data, isWeekly , XAxisFont=19, YAxisFont=20, height=300, xInterval=0, yTickStep=0, preformattedLabels=false}) => {
  // Calculate the minimum and maximum values
  const minValue = Math.min(...data.map(d => d.price));
  const maxValue = Math.max(...data.map(d => d.price));

  // Calculate 20% below the min value and 20% above the max value
  const buffer = (maxValue - minValue) * 0.2;
  const adjustedMin = Math.floor(minValue - buffer); // Round down
  const adjustedMax = Math.ceil(maxValue + buffer);  // Round up

  // yTickStep snaps the axis to round increments (e.g. 250 / 500) instead of letting recharts pick
  // ticks off a buffered min/max, which yields values like $3,538 / $3,721. Defaults to 0, which
  // keeps the previous auto behaviour for every existing caller.
  let yDomain = [adjustedMin, adjustedMax];
  let yTicks;
  if (yTickStep > 0 && isFinite(minValue) && isFinite(maxValue)) {
    const lo = Math.floor(minValue / yTickStep) * yTickStep;
    const hi = Math.ceil(maxValue / yTickStep) * yTickStep;
    yDomain = [lo, hi === lo ? lo + yTickStep : hi];
    yTicks = [];
    for (let v = yDomain[0]; v <= yDomain[1]; v += yTickStep) yTicks.push(v);
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 10, right: 0, left: 10, bottom: 50 }}>
        <XAxis 
          dataKey="year" 
          tick={{ fill: theme === "dark" ? "#f8ffef" : 'rgb(102, 102, 102)',  fontWeight: 600,fontSize: XAxisFont }} 
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : '#eee' }} 
          tickLine={false} 
          interval={xInterval}
          angle={-45} 
          textAnchor="end"
          padding={{ left: 20, right: 20 }}  
          height={50}
          tickFormatter={ preformattedLabels ? (tick) => tick : (tick) => formatDate(tick,isWeekly )} 
        />
        <YAxis
          tick={{ fill: theme === "dark" ? "#f8ffef" : 'rgb(102, 102, 102)',  fontWeight: 600,fontSize: YAxisFont, dx: 5 }}
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : '#eee' }}
          tickLine={false}
          tickCount={8}
          domain={yDomain}
          ticks={yTicks}
          width={_axisWidth(yTicks || yDomain, YAxisFont)}
          tickFormatter={_formatAxisPrice}
        />
        <Line 
          type="monotone" 
          dataKey="price" 
          className="line-chart-element"
          strokeWidth={4} 
          dot={false}
          strokeLinecap="butt"  
        >
        </Line>
      </LineChart>
    </ResponsiveContainer>
  );
};

export default CustomLineChart;
